
import Vue from "vue";
import { mapState } from "vuex";
import { User } from "@/api/users";

export interface BlackBoardDlgSelection {
  selectedBlackBoardRef: string;
  confirm: boolean;
}
// eslint-disable-next-line
const ConfirmDlgBlackBoards: any = Vue.extend({
  name: "ConfirmDlgBlackBoards",
  props: {
    labelOk: {
      type: String,
      default: "Mit Flamme weiter",
    },
    labelOkWithoutSelection: {
      type: String,
      default: "Ohne Flamme weiter",
    },
    labelCancel: {
      type: String,
      default: "Abbruch",
    },
  },
  data() {
    return {
      dialog: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      resolve: (v: BlackBoardDlgSelection) => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      reject: (v: BlackBoardDlgSelection) => {},
      message: "",
      title: "",
      options: {
        textColor: "grey lighten-3",
        width: 600,
        zIndex: 200,
        noconfirm: false,
        textOk: this.labelOk,
        textOkSecond: this.labelOkWithoutSelection,
        textCancel: this.labelCancel,
        currentBlackBoard: "",
      },
    };
  },
  computed: {
    ...mapState("taskboard", ["blackBoards"]),
  },
  methods: {
    // eslint-disable-next-line
    open(title: string, message: string, options: any) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve({ confirm: true, selectedBlackBoardRef: this.options.currentBlackBoard });
      this.dialog = false;
    },
    agreeWithoutSelection() {
      this.resolve({ confirm: true, selectedBlackBoardRef: "" });
      this.dialog = false;
    },
    cancel() {
      this.resolve({ confirm: false, selectedBlackBoardRef: "" });
      this.dialog = false;
    },
  },
});

export default ConfirmDlgBlackBoards;
